// src/components/HomePage.jsx
import React, { useState, useEffect } from "react";
import "./adminSampleKPI.css";
import { supabase } from '../../supabase_client.jsx';

export default function AdminKpi2C({ onViewSelect }) {
  const [userCount, setUserCount] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchUserCount() {
      try {
        const { data, error } = await supabase.rpc("get_admin_currevents");

        if (error) throw error;

        // data is the integer returned by the SQL function
        setUserCount(data);
      } catch (err) {
        setError(err.message);
      }
    }

    fetchUserCount();
  }, []);


  return (
    <div className="home-container">
      <div className="home-card">

        {/* Top nav bar */}
        <div className="top-nav">
          <div className="nav-left">
            <button className="nav-tab"  onClick={() => onViewSelect('admin')}
            >
              General
            </button>
            <button className="nav-tab" onClick={() => onViewSelect('adminCalendar')}
            >
              Event Calendar
            </button>
            <button className="nav-tab" onClick={() => onViewSelect('adminEventManagement')}
            >
              Event Management
            </button>
            <button className="nav-tab active">KPI Dashboard</button>
            <button className="nav-tab" onClick={() => onViewSelect('user-management')}>
              User Management
            </button>
            <button className="nav-tab" onClick={() => onViewSelect('business-management')}>
              Business Management
            </button>
            <button className="bpActionBtn secondary" onClick={() => {
            sessionStorage.removeItem("currentUser");
            sessionStorage.removeItem("currentView");
            onViewSelect("loginSignup");
          }}>
            Log Out
          </button>
          </div>
        </div>
        
        <div className="dash-title-container">
          <button className="return-button"onClick={() => onViewSelect('adminKPIDash')} >Go Back</button>
        </div>

        <div>
          <h1 className="home-title"> Current Events Listed </h1>
        </div>

        <div className="kpi-display">
            <h2 className="kpi-number">{userCount}</h2>
        </div>

        {/* Optional: show error if needed (kept minimal) */}
        {error && (
          <div style={{ marginTop: "10px", color: "crimson" }}>
            Error: {error}
          </div>
        )}

      </div>
    </div>
  );
}